import { PropsWithChildren } from "react";
import { useSelector } from "react-redux";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";

import { selectIsApplicationReady } from "Store/Selectors/UI";
import { useLoadingIndicatorStyles } from "./UseLoadingIndicatorStyles";
import { useGlobalStyles } from "../../../Hooks/UseGlobalStyles";

export function LoadingIndicator(props: PropsWithChildren<unknown>): JSX.Element {
  const { children } = props;
  const styles = useLoadingIndicatorStyles();

  useGlobalStyles();
  const isApplicationReady = useSelector(selectIsApplicationReady);

  return (
    <>
      {children}
      {!isApplicationReady && <Spinner size={SpinnerSize.large} className={styles.loadingIndicator} />}
    </>
  );
}
